import themeVariables from "@Theme/exportColor.module.scss";

const CloseIcon = ({
  size = 18,
  stroke = themeVariables.neutral5,
  viewBox = "0 0 18 18",
  strokeWidth = "3",
  style = {},
}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={viewBox}
    style={style}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
    >
      <path d="M16 0L0 16M0 0L16 16" transform="translate(1 1)" />
    </g>
  </svg>
);
export default CloseIcon;
